export const GET_META_INFO = "GET_META_INFO";
export const GET_META_INFO_SUCCESS = "GET_META_INFO_SUCCESS";
export const GET_META_INFO_FAILED = "GET_META_INFO_FAILED";

export const GET_ALL_CONTRACTS = "GET_ALL_CONTRACTS";
export const GET_ALL_CONTRACTS_SUCCESS = "GET_ALL_CONTRACTS_SUCCESS";
export const GET_ALL_CONTRACTS_FAILED = "GET_ALL_CONTRACTS_FAILED";

export const CREATE_CONTRACT = "CREATE_CONTRACT";
export const CREATE_CONTRACT_SUCCESS = "CREATE_CONTRACT_SUCCESS";
export const CREATE_CONTRACT_FAILED = "CREATE_CONTRACT_FAILED";

export const UPDATE_CONTRACT = "UPDATE_CONTRACT";
export const UPDATE_CONTRACT_SUCCESS = "UPDATE_CONTRACT_SUCCESS";
export const UPDATE_CONTRACT_FAILED = "UPDATE_CONTRACT_FAILED";

export const DELETE_CONTRACT = "DELETE_CONTRACT";
export const DELETE_CONTRACT_SUCCESS = "DELETE_CONTRACT_SUCCESS";
export const DELETE_CONTRACT_FAILED = "DELETE_CONTRACT_FAILED";

export const GET_SUPPLIER_REGIONS = "GET_SUPPLIER_REGIONS";
export const GET_SUPPLIER_REGIONS_SUCCESS = "GET_SUPPLIER_REGIONS_SUCCESS";
export const GET_SUPPLIER_REGIONS_FAILED = "GET_SUPPLIER_REGIONS_FAILED";

export const GET_SUPPLIER_LOCATIONS = "GET_SUPPLIER_LOCATIONS";
export const GET_SUPPLIER_LOCATIONS_SUCCESS = "GET_SUPPLIER_LOCATIONS_SUCCESS";
export const GET_SUPPLIER_LOCATIONS_FAILED = "GET_SUPPLIER_LOCATIONS_FAILED";

export const TOGGLE_CUSTOM_LIST_ITEM = "TOGGLE_CUSTOM_LIST_ITEM";
export const ENABLE_ALL_CUSTOM_LIST_ITEMS = "ENABLE_ALL_CUSTOM_LIST_ITEMS";
export const DISABLE_ALL_CUSTOM_LIST_ITEMS = "DISABLE_ALL_CUSTOM_LIST_ITEMS";

export const GET_CONTRACT_DETAIL = "GET_CONTRACT_DETAIL";
export const GET_CONTRACT_DETAIL_SUCCESS = "GET_CONTRACT_DETAIL_SUCCESS";
export const GET_CONTRACT_DETAIL_FAILED = "GET_CONTRACT_DETAIL_FAILED";

export const SET_CONTRACT_LOCATIONS = "SET_CONTRACT_LOCATIONS";
export const SET_CONTRACT_REGIONS = "SET_CONTRACT_REGIONS";
export const IS_PICK_UP_UPDATING = "IS_PICK_UP_UPDATING";
export const IS_REGION_UPDATING = "IS_REGION_UPDATING";

export const GET_REGION_COUNTRIES = "GET_REGION_COUNTRIES";
export const GET_REGION_COUNTRIES_SUCCESS = "GET_REGION_COUNTRIES_SUCCESS";
export const GET_REGION_COUNTRIES_FAILED = "GET_REGION_COUNTRIES_FAILED";

export const SET_SELECTED_CONTRACT = "SET_SELECTED_CONTRACT";

export const SELECT_CONTRACT = "SELECT_CONTRACT";
export const CONTRACT_SUPPLIER_UPDATING = "CONTRACT_SUPPLIER_UPDATING";

export const createContract = (payload, setSubmiting, hideModal) => ({
  type: CREATE_CONTRACT,
  payload,
  setSubmiting,
  hideModal,
});

export const updateContract = (payload, setSubmiting, hideModal) => ({
  type: UPDATE_CONTRACT,
  payload,
  setSubmiting,
  hideModal,
});

export const deleteContract = (payload, hideModal) => ({
  type: DELETE_CONTRACT,
  payload,
  hideModal,
});

export const getContractDetail = (id, showModal) => ({
  type: GET_CONTRACT_DETAIL,
  id,
  showModal,
});

export const getContractMetaInfo = () => ({
  type: GET_META_INFO,
});

export const getSupplierRegions = (supplier_id) => ({
  type: GET_SUPPLIER_REGIONS,
  supplier_id,
});

export const getAllContracts = () => ({
  type: GET_ALL_CONTRACTS,
});

export const selectContract = () => ({
  type: SELECT_CONTRACT,
});

export const getSupplierLocations = (payload) => ({
  type: GET_SUPPLIER_LOCATIONS,
  payload,
});

export const toggleCustomListItem = (id, name) => ({
  type: TOGGLE_CUSTOM_LIST_ITEM,
  id,
  name,
});

export const enableAllCustomListItem = (name) => ({
  type: ENABLE_ALL_CUSTOM_LIST_ITEMS,
  name,
});

export const disableAllCustomListItem = (name) => ({
  type: DISABLE_ALL_CUSTOM_LIST_ITEMS,
  name,
});

export const setContractRegions = (payload) => ({
  type: SET_CONTRACT_REGIONS,
  payload,
});

export const setContractLocations = (payload) => ({
  type: SET_CONTRACT_LOCATIONS,
  payload,
});

export const setPickupUpdating = (payload) => ({
  type: IS_PICK_UP_UPDATING,
  payload,
});

export const setRegionUpdating = (payload) => ({
  type: IS_REGION_UPDATING,
  payload,
});

export const setSupplierContractUpdating = (payload) => ({
  type: CONTRACT_SUPPLIER_UPDATING,
  payload,
});

export const getRegionsCountries = (payload) => ({
  type: GET_REGION_COUNTRIES,
  payload,
});

export const setSelectedContract = (payload) => ({
  type: SET_SELECTED_CONTRACT,
  payload,
});
